import { render } from "./process_documentation_managementByIdView.vue?vue&type=template&id=1e9418bb"
import script from "./process_documentation_managementByIdView.vue?vue&type=script&lang=js"
export * from "./process_documentation_managementByIdView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__